module.exports = __webpack_public_path__ + "45bccd9f30dfeea8f5e358ba31f84dfb.png";